import { flag, integer, list, optionalText, record, text } from '../../../shared/decode'
import type { OwnCashier, OwnCashierLink, OwnCashierList } from '../model/types'

function link(raw: unknown, name: string): OwnCashierLink {
  const v = record(raw, name)
  return { resourceId: text(v.resourceId, name), resourceName: optionalText(v.resourceName, name) ?? '', key: text(v.key, name), name: optionalText(v.name, name) ?? '',
    sourceCashierId: optionalText(v.sourceCashierId, name),
    allowedRegisters: Array.isArray(v.allowedRegisters) ? list(v.allowedRegisters, `${name}.allowedRegisters`, (item, itemName) => text(item, itemName)) : null }
}

export function decodeOwnCashier(raw: unknown, name = 'cashier'): OwnCashier {
  const v = record(raw, name)
  return {
    id: text(v.id, name), displayName: text(v.displayName, name), lastName: optionalText(v.lastName, name), firstName: optionalText(v.firstName, name),
    middleName: optionalText(v.middleName, name), position: optionalText(v.position, name), archived: flag(v.archived, name), version: integer(v.version, name),
    hasCode: flag(v.hasCode, name), codeVersion: integer(v.codeVersion, name), canEdit: flag(v.canEdit, name), links: list(v.links, `${name}.links`, link),
  }
}

export function decodeOwnCashierList(raw: unknown): OwnCashierList {
  const v = record(raw, 'cashiers')
  return {
    items: list(v.items, 'items', decodeOwnCashier),
    sources: list(v.sources, 'sources', (entry, name) => {
      const s = record(entry, name); const kind = optionalText(s.kind, name)
      return { id: text(s.id, name), name: text(s.name, name), ...(kind === null || kind === '' ? {} : { kind }) }
    }),
    canManage: flag(v.canManage, 'canManage'), codeMinLength: integer(v.codeMinLength, 'codeMinLength'), codeMaxLength: integer(v.codeMaxLength, 'codeMaxLength'),
  }
}
